import { render, staticRenderFns } from "./JobMatch.vue?vue&type=template&id=1f981e55&scoped=true"
import script from "./JobMatch.vue?vue&type=script&lang=js"
export * from "./JobMatch.vue?vue&type=script&lang=js"
import style0 from "./JobMatch.vue?vue&type=style&index=0&id=1f981e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f981e55",
  null
  
)

export default component.exports